(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klimek-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TAPE_MS = 400;
    var DELAY = TAPE_MS + 1;
    var DURATION = 3200;
    var STRIPS = 150;
    var BAND = 0.34;

    function noiseTile() {
      var tile = document.createElement('canvas');
      tile.width = 128;
      tile.height = 128;
      var c = tile.getContext('2d');
      for (var y = 0; y < 128; y += 3) {
        for (var x = 0; x < 128; x += 3) {
          c.fillStyle = 'rgba(0,0,0,' + (0.25 + Math.random() * 0.75).toFixed(3) + ')';
          c.fillRect(x, y, 3, 3);
        }
      }
      return tile;
    }

    function burst(section, img) {
      var rect = img.getBoundingClientRect();
      var host = img.parentNode.getBoundingClientRect();
      var cs = window.getComputedStyle(img);
      var padL = parseFloat(cs.paddingLeft) || 0;
      var padR = parseFloat(cs.paddingRight) || 0;
      var padT = parseFloat(cs.paddingTop) || 0;
      var padB = parseFloat(cs.paddingBottom) || 0;

      var cw = rect.width - padL - padR;
      var ch = rect.height - padT - padB;
      if (cw <= 0 || ch <= 0) return;

      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var canvas = document.createElement('canvas');
      canvas.className = 'klimek-signup__burst';
      canvas.width = Math.round(cw * dpr);
      canvas.height = Math.round(ch * dpr);
      canvas.style.left = (rect.left - host.left + padL) + 'px';
      canvas.style.top = (rect.top - host.top + padT) + 'px';
      canvas.style.width = cw + 'px';
      canvas.style.height = ch + 'px';
      img.parentNode.insertBefore(canvas, img.nextSibling);

      var ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);
      var pattern = ctx.createPattern(noiseTile(), 'repeat');

      var ratio = img.naturalWidth / img.naturalHeight;
      var dw = cw;
      var dh = cw / ratio;
      if (dh > ch) {
        dh = ch;
        dw = ch * ratio;
      }
      var dx = (cw - dw) / 2;
      var dy = (ch - dh) / 2;
      var stripH = dh / STRIPS;
      var srcH = img.naturalHeight / STRIPS;

      var jitter = [];
      var sway = [];
      for (var j = 0; j < STRIPS; j++) {
        jitter.push((Math.random() - 0.5) * 0.14);
        sway.push((Math.random() - 0.5) * 2);
      }

      img.style.opacity = '0';

      var start = null;
      function frame(now) {
        if (start === null) start = now;
        var p = Math.min(1, Math.max(0, (now - start - DELAY) / DURATION));
        var front = (1 + BAND) * (1 - Math.pow(1 - p, 1.45));

        ctx.clearRect(0, 0, cw, ch);

        for (var i = 0; i < STRIPS; i++) {
          var top = i / STRIPS;
          var local = (front - top) / BAND + jitter[i];
          if (local >= 1) continue;
          if (local < 0) local = 0;

          var eased = local * local;
          var lift = eased * dh * 0.2;
          var drift = sway[i] * eased * 22;
          var y = dy + top * dh - lift;

          ctx.globalCompositeOperation = 'source-over';
          ctx.globalAlpha = 1;
          ctx.drawImage(img, 0, i * srcH, img.naturalWidth, srcH, dx + drift, y, dw, stripH + 2);

          if (local > 0) {
            ctx.globalCompositeOperation = 'destination-out';
            ctx.globalAlpha = Math.min(1, local * 2.2);
            ctx.fillStyle = pattern;
            ctx.fillRect(dx + drift - 40, y, dw + 80, stripH + 2);
            if (local > 0.5) {
              ctx.globalAlpha = (local - 0.5) / 0.5;
              ctx.fillStyle = '#000';
              ctx.fillRect(dx + drift - 40, y, dw + 80, stripH + 2);
            }
          }
        }

        if (p < 1) {
          requestAnimationFrame(frame);
        } else {
          canvas.parentNode.removeChild(canvas);
        }
      }
      requestAnimationFrame(frame);
    }

    /* Alle Folien liegen uebereinander im Bildausschnitt. "lazy" haelt sie
       deshalb nicht zurueck — sie wuerden alle sofort geladen und die erste
       Ansicht unnoetig schwer machen. Darum traegt das Skript sie nach:
       erst wenn die Seite steht, und dann eine nach der anderen. */
    function nachladen(section) {
      var offen = [].slice.call(section.querySelectorAll('[data-klimek-spaet]'));
      if (!offen.length) return;

      function naechste() {
        var bild = offen.shift();
        if (!bild) return;
        bild.addEventListener('load', naechste, { once: true });
        bild.addEventListener('error', naechste, { once: true });
        var satz = bild.getAttribute('data-klimek-spaet-satz');
        if (satz) bild.setAttribute('srcset', satz);
        bild.setAttribute('src', bild.getAttribute('data-klimek-spaet'));
        bild.removeAttribute('data-klimek-spaet');
        bild.removeAttribute('data-klimek-spaet-satz');
      }

      if (document.readyState === 'complete') naechste();
      else window.addEventListener('load', naechste, { once: true });
    }

    function rotate(section) {
      var slides = section.querySelectorAll('.klimek-signup__product');
      if (slides.length < 2) return;

      var every = parseInt(section.getAttribute('data-klimek-interval'), 10);
      if (!every || every < 1000) every = 4000;

      var i = 0;
      var timer = setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, every);

      section.addEventListener('klimek:stop', function () { clearInterval(timer); });
    }

    function dissolve(marker) {
      var section = marker.closest('.klimek-signup');
      if (!section) return;

      section.dispatchEvent(new Event('klimek:stop'));

      var img = section.querySelector('.klimek-signup__product.is-active') ||
                section.querySelector('.klimek-signup__product');
      if (!img) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        img.style.transition = 'opacity 0.6s linear 0.55s';
        img.style.opacity = '0';
        return;
      }

      if (img.complete && img.naturalWidth) {
        burst(section, img);
      } else {
        img.addEventListener('load', function () { burst(section, img); });
      }
    }

    function pruefung(section) {
      var form = section.querySelector('.klimek-signup__form');
      if (!form) return;
      var feld = form.querySelector('input[type="email"]');
      if (!feld) return;

      var standard = feld.getAttribute('placeholder') || '';
      var meldung = section.getAttribute('data-klimek-fehler') || 'BITTE E-MAIL-ADRESSE PRUEFEN';

      form.addEventListener('submit', function (e) {
        var wert = feld.value.trim();
        var gueltig = wert.length > 4 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(wert);
        if (gueltig) return;
        e.preventDefault();
        feld.value = '';
        feld.setAttribute('placeholder', meldung);
        feld.classList.add('is-fehler');
        feld.focus();
      });

      feld.addEventListener('input', function () {
        if (!feld.classList.contains('is-fehler')) return;
        feld.classList.remove('is-fehler');
        feld.setAttribute('placeholder', standard);
      });
    }

    function init() {
      var markers = document.querySelectorAll('[data-klimek-dissolve]');
      for (var i = 0; i < markers.length; i++) dissolve(markers[i]);

      var sections = document.querySelectorAll('.klimek-signup');
      for (var j = 0; j < sections.length; j++) {
        pruefung(sections[j]);
        nachladen(sections[j]);
        if (!sections[j].querySelector('[data-klimek-dissolve]')) rotate(sections[j]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klimek-produkt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Einblenden der unteren Abschnitte */
    function einblenden(wurzel) {
      var ziele = wurzel.querySelectorAll('[data-zeigen]');
      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < ziele.length; i++) ziele[i].classList.add('is-sichtbar');
        return;
      }
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-sichtbar');
          beobachter.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      for (var j = 0; j < ziele.length; j++) beobachter.observe(ziele[j]);
    }

    /* Galerie: Wischen macht der Browser. Pfeile, Punkte und Pfeiltasten
       springen gezielt zu einer Aufnahme; abgelesen wird an der Scrollstelle. */
    function galerie(wurzel) {
      var spur = wurzel.querySelector('[data-galerie]');
      var punkte = wurzel.querySelector('[data-punkte]');
      if (!spur || !punkte) return;
      var rahmen = spur.querySelectorAll('.klimek-pd__rahmen');
      if (rahmen.length < 2) return;
      var zurueck = wurzel.querySelector('[data-zurueck]');
      var weiter = wurzel.querySelector('[data-weiter]');
      var stand = wurzel.querySelector('[data-stand]');
      var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var anzahl = rahmen.length;
      var aktuell = 0;

      for (var i = 0; i < anzahl; i++) {
        var pkt = document.createElement('button');
        pkt.type = 'button';
        pkt.className = 'klimek-pd__punkt' + (i === 0 ? ' is-da' : '');
        pkt.setAttribute('aria-label', 'Aufnahme ' + (i + 1) + ' von ' + anzahl);
        if (i === 0) pkt.setAttribute('aria-current', 'true');
        pkt.setAttribute('data-ziel', i);
        punkte.appendChild(pkt);
      }
      var alle = punkte.children;

      function gehe(index) {
        index = Math.max(0, Math.min(anzahl - 1, index));
        spur.scrollTo({ left: index * spur.clientWidth, behavior: ruhig ? 'auto' : 'smooth' });
      }

      function zeigen(index) {
        if (index === aktuell && alle[index].classList.contains('is-da')) return;
        aktuell = index;
        for (var k = 0; k < alle.length; k++) {
          alle[k].classList.toggle('is-da', k === index);
          if (k === index) alle[k].setAttribute('aria-current', 'true');
          else alle[k].removeAttribute('aria-current');
        }
        if (zurueck) zurueck.disabled = index === 0;
        if (weiter) weiter.disabled = index === anzahl - 1;
        if (stand) stand.textContent = 'Aufnahme ' + (index + 1) + ' von ' + anzahl;
      }

      var warte = false;
      function ablesen() {
        warte = false;
        var breite = spur.clientWidth || 1;
        zeigen(Math.max(0, Math.min(anzahl - 1, Math.round(spur.scrollLeft / breite))));
      }
      spur.addEventListener('scroll', function () {
        if (warte) return;
        warte = true;
        window.requestAnimationFrame(ablesen);
      }, { passive: true });
      window.addEventListener('resize', function () { gehe(aktuell); });

      if (zurueck) {
        zurueck.hidden = false;
        zurueck.addEventListener('click', function () { gehe(aktuell - 1); });
      }
      if (weiter) {
        weiter.hidden = false;
        weiter.addEventListener('click', function () { gehe(aktuell + 1); });
      }
      punkte.addEventListener('click', function (e) {
        var ziel = e.target.closest ? e.target.closest('[data-ziel]') : null;
        if (ziel) gehe(parseInt(ziel.getAttribute('data-ziel'), 10));
      });
      spur.addEventListener('keydown', function (e) {
        var neu = null;
        if (e.key === 'ArrowRight') neu = aktuell + 1;
        else if (e.key === 'ArrowLeft') neu = aktuell - 1;
        else if (e.key === 'Home') neu = 0;
        else if (e.key === 'End') neu = anzahl - 1;
        if (neu === null) return;
        e.preventDefault();
        gehe(neu);
      });

      if (zurueck) zurueck.disabled = true;
    }

    /* Die Kaufleiste zeigt dasselbe Teil wie oben. Sie spiegelt die
       Groessenkacheln, damit unten nicht erneut gewaehlt werden muss. */
    /* "Nur noch X in Groesse" aus data-bestand der gewaehlten Groesse. */
    function knapp(wurzel) {
      var zeile = wurzel.querySelector('[data-knapp]');
      var form = wurzel.querySelector('.klimek-pd__form');
      if (!zeile || !form) return;
      var schwelle = parseInt(zeile.getAttribute('data-schwelle'), 10) || 0;
      var vorlage = zeile.getAttribute('data-vorlage') || '';
      function zeigen() {
        var r = form.querySelector('.klimek-p__radio:checked');
        var n = r ? parseInt(r.getAttribute('data-bestand'), 10) : NaN;
        /* Steht der Regler auf einer ausverkauften Groesse, gehoert die
           Zeile der zuletzt lieferbaren Groesse nicht darunter. */
        var schieber = form.querySelector('[data-regler-schieber]');
        var kasten = form.querySelector('[data-regler]');
        if (schieber && kasten && !kasten.hidden) {
          var alle = form.querySelectorAll('[data-groessen] .klimek-p__radio');
          var dort = alle[parseInt(schieber.value, 10)];
          if (dort && dort.disabled) n = NaN;
        }
        if (schwelle > 0 && n > 0 && n <= schwelle) {
          zeile.textContent = vorlage.replace('[n]', n).replace('[g]', r.getAttribute('data-titel') || '');
          zeile.hidden = false;
        } else {
          zeile.textContent = '';
          zeile.hidden = true;
        }
      }
      zeigen();
      wurzel.addEventListener('change', function () { window.setTimeout(zeigen, 0); });
    }

    function leiste(wurzel) {
      var bar = wurzel.querySelector('[data-leiste]');
      var form = wurzel.querySelector('.klimek-pd__form');
      if (!bar || !form) return;
      var feld = bar.querySelector('[data-leiste-groesse]');
      var preisOben = wurzel.querySelector('[data-preis-anzeige]');
      var preisUnten = bar.querySelector('[data-leiste-preis]');

      function spiegeln() {
        var quellen = form.querySelectorAll('.klimek-p__radio');
        while (feld.childNodes.length > 1) feld.removeChild(feld.lastChild);
        for (var i = 0; i < quellen.length; i++) {
          var q = quellen[i];
          var kennung = 'leiste-' + q.value;
          var knopf = document.createElement('input');
          knopf.type = 'radio';
          knopf.name = 'id';
          knopf.className = 'klimek-p__radio';
          knopf.id = kennung;
          knopf.value = q.value;
          knopf.disabled = q.disabled;
          knopf.checked = q.checked;
          var kachel = document.createElement('label');
          kachel.className = 'klimek-p__chip' + (q.disabled ? ' klimek-p__chip--weg' : '');
          kachel.setAttribute('for', kennung);
          kachel.appendChild(document.createTextNode(q.getAttribute('data-titel') || q.value));
          if (q.disabled) {
            var zusatz = document.createElement('span');
            zusatz.className = 'klimek-versteckt';
            zusatz.textContent = ' — ausverkauft';
            kachel.appendChild(zusatz);
          }
          feld.appendChild(knopf);
          feld.appendChild(kachel);
        }
        var gewaehlt = feld.querySelector('.klimek-p__radio:checked');
        if (gewaehlt) {
          var dazu = feld.querySelector('label[for="' + gewaehlt.id + '"]');
          if (dazu) feld.scrollLeft = Math.max(0, dazu.offsetLeft - feld.clientWidth / 2 + dazu.offsetWidth / 2);
        }
      }
      spiegeln();

      /* Preis folgt der Groesse, wo sich die Varianten unterscheiden. Beide
         Richtungen, damit oben und unten nie auseinanderlaufen. */
      wurzel.addEventListener('change', function (e) {
        var ziel = e.target;
        if (!ziel.classList || !ziel.classList.contains('klimek-p__radio')) return;
        var imFormular = form.contains(ziel);
        if (imFormular) {
          var spiegel = feld.querySelector('input[value="' + ziel.value + '"]');
          if (spiegel) spiegel.checked = true;
        } else {
          var original = form.querySelector('input[value="' + ziel.value + '"]');
          if (original) {
            original.checked = true;
            /* Der Regler oben zog nicht mit: Unten XL gewaehlt, oben stand
               weiter XS (gemessen 10.10., Crewneck 390). Ihn auf dieselbe
               Stufe stellen und wie eine eigene Eingabe melden — dann laufen
               Anzeige, Knappheitszeile und Kaufknopf ueber denselben Weg. */
            var schieber = form.querySelector('[data-regler-schieber]');
            if (schieber) {
              var liste = form.querySelectorAll('[data-groessen] .klimek-p__radio');
              var stelle = Array.prototype.indexOf.call(liste, original);
              if (stelle >= 0 && String(stelle) !== schieber.value) {
                schieber.value = stelle;
                schieber.dispatchEvent(new Event('input', { bubbles: true }));
              }
            }
          }
        }
        var preis = (imFormular ? ziel : form.querySelector('input[value="' + ziel.value + '"]') || ziel)
          .getAttribute('data-preis');
        if (preis) {
          if (preisOben) preisOben.textContent = preis;
          if (preisUnten) preisUnten.textContent = preis;
          wurzel.setAttribute('data-preis', preis);
        }
      });

      /* Die Leiste erscheint, sobald der obere Kaufknopf aus dem Bild ist.
         Frueher meldete das ein IntersectionObserver — der meldet sich aber
         nur, wenn der Knopf einmal im Bild war. Ein Sprung ueber ihn hinweg
         (Ende-Taste, Sprungmarke, Telefon mit Knopf unter dem Rand) liess
         die Leiste weg (gemessen 10.10.: 320/390 nach Sprung ans Ende).
         Jetzt zaehlt nur die Lage des Knopfs, einmal je Bild. */
      var oben = form.querySelector('button[type="submit"]');
      if (!oben) { bar.classList.add('is-da'); return; }
      var wartet = false;
      function lage() {
        wartet = false;
        bar.classList.toggle('is-da', oben.getBoundingClientRect().bottom < 0);
      }
      function anstossen() {
        if (wartet) return;
        wartet = true;
        window.requestAnimationFrame(lage);
      }
      window.addEventListener('scroll', anstossen, { passive: true });
      window.addEventListener('resize', anstossen);
      lage();
    }

    function start() {
      var wurzeln = document.querySelectorAll('.klimek-pd');
      for (var i = 0; i < wurzeln.length; i++) {
        einblenden(wurzeln[i]);
        galerie(wurzeln[i]);
        leiste(wurzeln[i]);
        knapp(wurzeln[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klimek-produkte"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function einblenden(wurzel) {
      /* Unterstuetzt der Browser scroll-getriebene Animationen, erledigt das
         CSS die Einblendung. Der Beobachter liefe dann doppelt. */
      if (CSS.supports && CSS.supports('animation-timeline', 'view()')) return;
      var ziele = wurzel.querySelectorAll('[data-zeigen]');
      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < ziele.length; i++) ziele[i].classList.add('is-sichtbar');
        return;
      }
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-sichtbar');
          beobachter.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      for (var j = 0; j < ziele.length; j++) beobachter.observe(ziele[j]);
    }

    /* ---------- Bilder der Buehne erst laden, wenn sie drankommen ----------
       Alle sechs Teile stehen technisch im Bildausschnitt, "lazy" allein laedt
       sie deshalb sofort alle. Geladen wird das aktive Teil und zwei voraus —
       genug Vorlauf, dass beim Scrollen nichts nachhinkt. */
    function bildLaden(teil) {
      if (!teil || teil.dataset.geladen) return;
      var bilder = teil.querySelectorAll('img[data-spaet]');
      /* Einmal gemerkt, damit der Scrollrechner nicht bei jedem Bild erneut
         durch alle Teile sucht. */
      teil.dataset.geladen = '1';
      for (var i = 0; i < bilder.length; i++) {
        var bild = bilder[i];
        var satz = bild.getAttribute('data-spaet-satz');
        if (satz) bild.setAttribute('srcset', satz);
        bild.setAttribute('src', bild.getAttribute('data-spaet'));
        bild.removeAttribute('data-spaet');
        bild.removeAttribute('data-spaet-satz');
      }
    }

    /* ---------- Echte Aufnahme hinter dem Roentgenbild ----------
       Mit der Maus: Darueberfahren zeigt das echte Teil, ein Klick fuehrt zur
       Seite. Auf dem Telefon gibt es kein Darueberfahren — dort zeigt der
       erste Tipp das echte Teil, und erst der zweite fuehrt weiter. Tastatur
       und Vorleseprogramme kommen ohne Umweg zur Seite: Sie loesen einen
       Klick ohne vorherigen Fingerdruck aus. */
    function echtLaden(bild) {
      if (!bild || !bild.hasAttribute('data-echt-src')) return;
      var satz = bild.getAttribute('data-echt-satz');
      if (satz) bild.setAttribute('srcset', satz);
      bild.setAttribute('src', bild.getAttribute('data-echt-src'));
      bild.removeAttribute('data-echt-src');
      bild.removeAttribute('data-echt-satz');
    }

    /* Bleibt jemand bei einem Teil der Buehne stehen, kommt dessen Aufnahme
       schon vorab — dann steht sie beim ersten Tipp sofort da. Wer nur
       durchscrollt, laedt sie nicht mit, und vor dem Rest der Seite schon
       gar nicht. */
    var vorgemerkt = null;
    var vormerkUhr = null;
    function echtVormerken(teil) {
      vorgemerkt = teil;
      window.clearTimeout(vormerkUhr);
      if (!teil) return;
      vormerkUhr = window.setTimeout(function () {
        var los = function () {
          if (vorgemerkt === teil) echtLaden(teil.querySelector('[data-echt-src]'));
        };
        if (document.readyState === 'complete') los();
        else window.addEventListener('load', los, { once: true });
      }, 700);
    }

    function echt(wurzel) {
      var ziele = [].slice.call(wurzel.querySelectorAll('[data-echt]')).filter(function (z) {
        /* Ohne echte Aufnahme gibt es nichts aufzudecken: Der erste Tipp
           fuehrt dort gleich zur Seite. */
        return z.querySelector('[data-echt-foto]') !== null;
      });
      if (!ziele.length) return;

      var zeiger = '';
      var gescrollt = 0;
      var tippY = null;

      /* Fuer den Hinweis in der Buehne: steht gerade ein Foto offen? */
      function offenMelden() {
        var offen = ziele.some(function (z) { return z.hasAttribute('data-echt-will'); });
        if (offen) wurzel.setAttribute('data-echt-offen', '');
        else wurzel.removeAttribute('data-echt-offen');
      }

      function wollen(ziel, an, perTipp) {
        wollenRoh(ziel, an, perTipp);
        offenMelden();
      }

      function wollenRoh(ziel, an, perTipp) {
        var bild = ziel.querySelector('[data-echt-foto]');
        if (!an) {
          ziel.removeAttribute('data-echt-will');
          ziel.removeAttribute('data-echt-tipp');
          ziel.classList.remove('ist-echt');
          return;
        }
        ziel.setAttribute('data-echt-will', '');
        ziel._echtY = window.scrollY;
        if (perTipp) ziel.setAttribute('data-echt-tipp', '');
        echtLaden(bild);
        /* Erst ueberblenden, wenn die Aufnahme da ist — sonst verschwaende
           das Roentgenbild in ein leeres Feld. */
        var zeigen = function () {
          if (ziel.hasAttribute('data-echt-will')) ziel.classList.add('ist-echt');
        };
        if (bild.complete && bild.naturalWidth) zeigen();
        else bild.addEventListener('load', zeigen, { once: true });
      }

      wurzel.addEventListener('pointerdown', function (e) { zeiger = e.pointerType || ''; }, true);

      window.addEventListener('scroll', function () {
        gescrollt = Date.now();
        /* Per Maus aufgedeckte Aufnahmen gehen beim Scrollen zurueck zum
           Roentgenbild — sonst reiste das Foto gedreht und vergroessert mit
           dem Teil aus der Buehne. Die naechste Mausbewegung deckt neu auf. */
        ziele.forEach(function (z) {
          if (!z.hasAttribute('data-echt-will') || z.hasAttribute('data-echt-tipp')) return;
          if (Math.abs(window.scrollY - (z._echtY || 0)) > 40) wollen(z, false);
        });
        /* Wer nach dem ersten Tipp weiterscrollt, ist beim naechsten Teil —
           dort soll der erste Tipp wieder nur aufdecken. */
        if (tippY !== null && Math.abs(window.scrollY - tippY) > window.innerHeight * 0.4) {
          tippY = null;
          ziele.forEach(function (z) { if (z.hasAttribute('data-echt-tipp')) wollen(z, false); });
        }
      }, { passive: true });

      ziele.forEach(function (ziel) {
        /* Auf Bewegung, nicht schon aufs Betreten: Beim Scrollen gleiten die
           Teile unter einem ruhenden Mauszeiger durch, und jedes zeigte sonst
           sein Foto statt des Roentgenbilds. */
        ziel.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse' || ziel.hasAttribute('data-echt-will')) return;
          if (Date.now() - gescrollt < 200) return;
          wollen(ziel, true, false);
        });
        ziel.addEventListener('pointerleave', function (e) {
          if (e.pointerType === 'mouse' && !ziel.hasAttribute('data-echt-tipp')) wollen(ziel, false);
        });
        ziel.addEventListener('click', function (e) {
          var art = zeiger;
          zeiger = '';
          if (art !== 'touch' && art !== 'pen') return;
          if (ziel.hasAttribute('data-echt-will')) return;
          e.preventDefault();
          ziele.forEach(function (z) { if (z !== ziel) wollen(z, false); });
          tippY = window.scrollY;
          wollen(ziel, true, true);
        });
      });

      /* Zurueck von der Produktseite: wieder bei den Roentgenbildern
         anfangen, sonst fuehrte der naechste Tipp ungefragt weiter. */
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) ziele.forEach(function (z) { wollen(z, false); });
      });
    }

    /* ---------- Warenkorb ohne Seitenneuladen ----------
       Ohne das laedt nach jedem Kauf die ganze Seite neu, der Besucher landet
       wieder oben und muss zurueckscrollen — bei einer Seite, die vom Scrollen
       lebt, der einzige echte Bruch. Gibt es keine Warenkorbschublade im Theme
       oder scheitert die Anfrage, geht das Formular den gewoehnlichen Weg. */
    function leiste(wurzel) {
      var bar = wurzel.querySelector('[data-leiste]');
      var waren = Array.prototype.slice.call(wurzel.querySelectorAll('[data-ware]'));
      if (!bar || !waren.length) return;

      /* Nach der Buehne bot die Leiste das zuletzt gesehene Teil an — das
         ist die Ledertasche, und die passte unter keinen der Abschnitte ueber
         Stoff, Naht und Bündchen. Deshalb nur noch, wenn eingeschaltet. */
      var mitLeiste = bar.hasAttribute('data-mitlaufen');
      var feldName = bar.querySelector('[data-leiste-name]');
      var feldPreis = bar.querySelector('[data-leiste-preis]');
      var feldGroesse = bar.querySelector('[data-leiste-groesse]');
      var knopf = bar.querySelector('button[type="submit"]');
      var spur = wurzel.querySelector('.klimek-b__spur');
      var aktuell = -1;

      function kachelnBauen(ware) {
        /* Die Leiste spiegelt die Groessen des aktiven Teils. Eigene Kennungen,
           damit die Beschriftungen nicht auf die Knoepfe des Teils zeigen. */
        var quellen = ware.querySelectorAll('.klimek-p__radio');
        while (feldGroesse.childNodes.length > 1) feldGroesse.removeChild(feldGroesse.lastChild);
        for (var i = 0; i < quellen.length; i++) {
          var q = quellen[i];
          var kennung = 'leiste-groesse-' + q.value;
          var knopfchen = document.createElement('input');
          knopfchen.type = 'radio';
          knopfchen.name = 'id';
          knopfchen.className = 'klimek-p__radio';
          knopfchen.id = kennung;
          knopfchen.value = q.value;
          knopfchen.disabled = q.disabled;
          knopfchen.checked = q.checked;
          var kachel = document.createElement('label');
          kachel.className = 'klimek-p__chip' + (q.disabled ? ' klimek-p__chip--weg' : '');
          kachel.setAttribute('for', kennung);
          /* Nur der reine Groessenname. Der sichtbare Text der Vorlage enthaelt
             zusaetzlich den Hinweis "ausverkauft", der dort ausschliesslich
             fuer Vorleseprogramme steht — abgeschrieben blaeht er die Kachel
             auf das Vierfache auf. */
          kachel.appendChild(document.createTextNode(q.getAttribute('data-titel') || q.value));
          if (q.disabled) {
            var zusatz = document.createElement('span');
            zusatz.className = 'klimek-versteckt';
            zusatz.textContent = ' — ausverkauft';
            kachel.appendChild(zusatz);
          }
          feldGroesse.appendChild(knopfchen);
          feldGroesse.appendChild(kachel);
        }
      }

      function uebernehmen(index) {
        if (index === aktuell || !waren[index]) return;
        aktuell = index;
        var ware = waren[index];
        echtVormerken(ware);

        feldName.textContent = ware.getAttribute('data-name') || '';
        feldPreis.textContent = ware.getAttribute('data-preis') || '';
        kachelnBauen(ware);

        /* Die gewaehlte Kachel ins Bild holen: In der Leiste passen nicht alle
           Groessen nebeneinander, und ausgerechnet die ausgewaehlte stand
           sonst manchmal ausserhalb. */
        var gewaehlt = feldGroesse.querySelector('.klimek-p__radio:checked');
        if (gewaehlt) {
          var kachelDazu = feldGroesse.querySelector('label[for="' + gewaehlt.id + '"]');
          if (kachelDazu) {
            feldGroesse.scrollLeft = Math.max(0, kachelDazu.offsetLeft - feldGroesse.clientWidth / 2 + kachelDazu.offsetWidth / 2);
          }
        }

        /* Teile ohne verknuepftes Produkt haben keine Groessen. "Ausverkauft"
           waere dort falsch — sie sind nicht vergriffen, sondern noch nicht
           im Shop. Also zeigt die Leiste bei ihnen nur den Namen und laesst
           Preis, Groessen und Knopf weg, statt etwas zu behaupten. */
        var kaufbar = ware.querySelector('.klimek-p__radio') !== null;
        bar.classList.toggle('klimek-p__leiste--nurname', !kaufbar);
        feldPreis.hidden = !kaufbar;
        feldGroesse.hidden = !kaufbar;
        knopf.hidden = !kaufbar;

        var lieferbar = ware.getAttribute('data-lieferbar') !== 'nein';
        knopf.disabled = !lieferbar;
        knopf.textContent = lieferbar
          ? bar.getAttribute('data-kaufen')
          : bar.getAttribute('data-ausverkauft');
      }

      if (spur) {
        /* Auf der Buehne stehen alle Teile gleichzeitig im Bild, ein
           Sichtbarkeitsbeobachter meldet deshalb alle auf einmal. Das aktive
           Teil ergibt sich stattdessen aus dem Fortschritt durch die Spur.
           Waehrend der Buehne bleibt die Leiste unten, weil dort bereits
           gekauft werden kann; danach begleitet sie das zuletzt gesehene
           Teil durch die Detailabschnitte. */
        var warte = false;
        var pruefen = function () {
          warte = false;
          var kasten = spur.getBoundingClientRect();
          var weg = kasten.height - window.innerHeight;
          var fortschritt = weg > 0 ? Math.min(Math.max(-kasten.top / weg, 0), 1) : 0;
          var index = Math.min(Math.floor(fortschritt * waren.length), waren.length - 1);
          uebernehmen(index);
          /* Bis zwei Teile voraus, und alles davor mit: Springt jemand mit
             der Bildlaufleiste mitten hinein, blieben uebersprungene Teile
             sonst ohne Bild. Geladenes meldet sich nicht noch einmal. */
          for (var k = 0; k <= index + 2 && k < waren.length; k++) bildLaden(waren[k]);
          bar.classList.toggle('is-da', mitLeiste && kasten.bottom < window.innerHeight * 0.5);
        };
        var anstossen = function () {
          if (warte) return;
          warte = true;
          window.requestAnimationFrame(pruefen);
        };
        window.addEventListener('scroll', anstossen, { passive: true });
        window.addEventListener('resize', anstossen, { passive: true });
        pruefen();
        return;
      }

      /* Ohne Buehne: das Teil melden, das gerade im Bild steht. */
      if (!('IntersectionObserver' in window)) { uebernehmen(0); return; }
      var sichtbar = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) uebernehmen(waren.indexOf(e.target));
        });
      }, { threshold: 0.35 });
      waren.forEach(function (w) { sichtbar.observe(w); });

      var schalter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          bar.classList.toggle('is-da', mitLeiste && !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      schalter.observe(waren[0]);
      uebernehmen(0);
    }

    /* Preis folgt der gewaehlten Groesse, wo sich die Varianten im Preis
       unterscheiden. */
    function preisNachziehen(wurzel) {
      wurzel.addEventListener('change', function (ereignis) {
        var knopf = ereignis.target;
        if (!knopf.classList || !knopf.classList.contains('klimek-p__radio')) return;
        var preis = knopf.getAttribute('data-preis');
        var ware = knopf.closest ? knopf.closest('[data-ware]') : null;
        if (!ware || !preis) return;
        var anzeige = ware.querySelector('.klimek-p__preis, .klimek-b__preis');
        if (anzeige) anzeige.textContent = preis;
        ware.setAttribute('data-preis', preis);

        /* Die Leiste nur dann mitziehen, wenn sie dieses Teil zeigt. Sonst
           bekam sie den Preis eines Teils, das gar nicht in ihr steht. */
        var leisteName = wurzel.querySelector('[data-leiste-name]');
        var leistePreis = wurzel.querySelector('[data-leiste-preis]');
        if (leisteName && leistePreis && leisteName.textContent === (ware.getAttribute('data-name') || '')) {
          leistePreis.textContent = preis;
        }
      });
    }

    /* Das kleine Logo erscheint, sobald das grosse oben aus dem Bild ist.
       Ohne Beobachter bleibt es einfach an — sichtbar ist besser als weg. */
    function mitlogo(wurzel) {
      var klein = wurzel.querySelector('[data-mitlogo]');
      var gross = wurzel.querySelector('.klimek-p__logo');
      if (!klein) return;
      if (!gross || !window.IntersectionObserver) { klein.classList.add('is-da'); return; }
      new IntersectionObserver(function (eintraege) {
        klein.classList.toggle('is-da', !eintraege[0].isIntersecting);
      }, { threshold: 0 }).observe(gross);
    }

    /* Umschalten zwischen Buehne und Raster. Beide stehen im Quelltext;
       hier wird nur sichtbar gemacht, was gewaehlt ist. Die Wahl merkt sich
       der Browser, damit sie beim naechsten Teil nicht wieder umspringt —
       faellt der Speicher aus, bleibt es bei der Buehne. */
    function ansicht(wurzel) {
      var leiste = wurzel.querySelector('[data-ansicht]');
      var buehne = wurzel.querySelector('.klimek-b');
      var raster = wurzel.querySelector('[data-kacheln]');
      var kaufleiste = wurzel.querySelector('[data-leiste]');
      if (!leiste || !buehne || !raster) return;
      var knoepfe = leiste.querySelectorAll('[data-ansicht-wahl]');

      var erzaehlung = wurzel.querySelectorAll('[data-erzaehlung]');

      function setzen(wahl, merken) {
        var raster_an = wahl === 'kacheln';
        buehne.hidden = raster_an;
        /* Das Raster bleibt in beiden Ansichten stehen: unter der Erzaehlung
           als Schluss, im Raster als einziger Inhalt. Nur seine Ueberschrift
           braucht es dann nicht. */
        var schlussTitel = wurzel.querySelector('[data-schluss-titel]');
        if (schlussTitel) schlussTitel.hidden = raster_an;
        /* Die Abschnitte ueber Stoff, Naht und Herkunft gehoeren zur
           Erzaehlung. Im Raster will jemand die Teile sehen, nicht lesen —
           dort bleiben sie weg, sonst waere der Unterschied nur kosmetisch. */
        for (var e = 0; e < erzaehlung.length; e++) erzaehlung[e].hidden = raster_an;
        /* Die mitlaufende Kaufleiste gehoert zur Buehne — im Raster wuerde
           sie ein Teil anbieten, das gar nicht im Bild steht. */
        if (kaufleiste) kaufleiste.classList.toggle('klimek-p__leiste--weg', raster_an);
        for (var i = 0; i < knoepfe.length; i++) {
          var an = knoepfe[i].getAttribute('data-ansicht-wahl') === wahl;
          knoepfe[i].classList.toggle('is-da', an);
          knoepfe[i].setAttribute('aria-pressed', an ? 'true' : 'false');
        }
        if (merken) { try { localStorage.setItem('klimek-ansicht', wahl); } catch (e) {} }
      }

      var gemerkt = null;
      try { gemerkt = localStorage.getItem('klimek-ansicht'); } catch (e) {}
      setzen(gemerkt === 'kacheln' ? 'kacheln' : 'buehne', false);

      for (var k = 0; k < knoepfe.length; k++) {
        knoepfe[k].addEventListener('click', function () {
          setzen(this.getAttribute('data-ansicht-wahl'), true);
          window.scrollTo({ top: 0, behavior: 'auto' });
        });
      }
    }

    /* ---------- Von selbst zum ersten Teil ----------
       Wer die Seite oeffnet, sieht zuerst Zeichen und Leitsatz. Viele
       scrollen nicht von sich aus weiter — die Seite faehrt deshalb nach
       einem kurzen Moment langsam bis zum ersten Teil der Buehne.
       Nicht, wenn: Bewegung reduziert ist, das Raster gewaehlt ist, die
       Seite schon gescrollt steht (Neuladen, Zurueck), ein Sprungziel (#)
       in der Adresse steht, oder der Besucher vorher selbst eingreift.
       Jede eigene Eingabe waehrend der Fahrt bricht sie sofort ab. */
    function hinfahren(wurzel) {
      var buehne = wurzel.querySelector('.klimek-b');
      if (!buehne || buehne.hidden) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (location.hash) return;
      try {
        var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        if (nav && nav.type === 'back_forward') return;
      } catch (e) {}

      var abgebrochen = false;
      var uhr = null;
      var ereignisse = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
      function abbrechen() {
        abgebrochen = true;
        window.clearTimeout(uhr);
        wurzel.removeAttribute('data-faehrt');
        ereignisse.forEach(function (n) { window.removeEventListener(n, abbrechen, true); });
      }
      ereignisse.forEach(function (n) { window.addEventListener(n, abbrechen, { capture: true, passive: true }); });

      uhr = window.setTimeout(function () {
        if (abgebrochen || buehne.hidden || window.scrollY > 8) { abbrechen(); return; }
        var ziel = Math.round(buehne.getBoundingClientRect().top + window.scrollY);
        var start = window.scrollY;
        var weg = ziel - start;
        if (weg < 40) { abbrechen(); return; }
        /* Langsam und weich: rund 1,6 s, egal wie weit. */
        var dauer = 1600;
        var t0 = null;
        wurzel.setAttribute('data-faehrt', '');
        function schritt(jetzt) {
          if (abgebrochen) return;
          if (t0 === null) t0 = jetzt;
          var x = Math.min(1, (jetzt - t0) / dauer);
          var k = x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
          window.scrollTo(0, start + weg * k);
          if (x < 1) window.requestAnimationFrame(schritt);
          else abbrechen();
        }
        window.requestAnimationFrame(schritt);
      }, 1100);
    }

    function start() {
      var wurzeln = document.querySelectorAll('.klimek-p');
      for (var i = 0; i < wurzeln.length; i++) {
        einblenden(wurzeln[i]);
        leiste(wurzeln[i]);
        preisNachziehen(wurzeln[i]);
        mitlogo(wurzeln[i]);
        ansicht(wurzeln[i]);
        echt(wurzeln[i]);
        hinfahren(wurzeln[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
